export const RESET_ERROR_MESSAGES = {
    general: "Failed to reset password. Please contact support",
    ssoOnly: "Your Tenant is configured for SSO only. Please sign in using Microsoft credentials.",
    resetCode: "Invalid password reset code",
    changesPassword: "New password should not be the same as old password."
}

export const COMMON_ERROR_MESSAGES = {
    general: "An internal error occurred during your request!"
}